// WHY: Define valid truthy values for flexible env flag parsing
const TRUTHY_VALUES = new Set(['1', 'true', 'yes', 'on']);

export const DEV_BYPASS_ACCESS_TOKEN = 'dev-preview-token';

export const devBypassAuthUser = {
  sub: 'auth0|dev-preview-user',
  email: 'maya.mercer+preview@besthuman.test',
  name: 'Maya Mercer',
  nickname: 'Maya'
};

// WHY: Auth bypass is restricted to local DEV environment and requires an explicit opt-in flag
export const isDevAuthBypassEnabled =
  import.meta.env.DEV && TRUTHY_VALUES.has((import.meta.env.VITE_DEV_BYPASS_AUTH ?? '').toLowerCase());
